import { useMemo } from 'react'

import { useReportData } from '../../../../hooks/useReportData'
import { PeriodValue } from '../../../../types/inputTypes'
import { useBalanceSheetFilters } from '../contexts/balanceSheetFiltersContext'
import { BalanceSheetInputBalance, BalanceSheetInputRowComponent } from '../types/inputTypes'
import { useFetchBalanceSheetReport } from './useFetchBalanceSheetData'

interface UseBalanceSheetDataReturn {
  allExpandableIds: string[]
  reportData: BalanceSheetInputRowComponent[]
  periods: PeriodValue[]
  isLoading: boolean
}

export const useBalanceSheetData = (): UseBalanceSheetDataReturn => {
  const { appliedFilters } = useBalanceSheetFilters()
  const { data, isLoading } = useFetchBalanceSheetReport({ appliedFilters })

  const { allExpandableIds, reportData, periods } = useReportData<BalanceSheetInputBalance>({
    data,
  })

  return useMemo(
    () => ({
      allExpandableIds,
      reportData,
      periods,
      isLoading,
    }),
    [allExpandableIds, reportData, periods, isLoading],
  )
}
